import { ConnectorSpec } from '@integration-app/sdk'
import ConnectorGuide, {
  GuideType,
} from '../../../routes/Connectors/Connector/guide'
import { CONNECTORS_API } from 'routes/constants'

export default function ConnectorGuidePage({
  connector,
  guide,
}: {
  connector: ConnectorSpec
  guide: GuideType
}) {
  return <ConnectorGuide connector={connector} guide={guide} />
}

export async function getServerSideProps({ params }) {
  // Fetch data from external API
  const connectorId = params.connectorKey

  const [connector, guide] = await Promise.all([
    fetchConnector(connectorId),
    fetchConnectorGuide(connectorId),
  ])

  // Pass data to the page via props
  return {
    props: { connector, guide },
  }
}

async function fetchConnector(connectorKey) {
  const res = await fetch(`${CONNECTORS_API}/${connectorKey}`)
  return await res.json()
}

async function fetchConnectorGuide(connectorKey) {
  const res = await fetch(`${CONNECTORS_API}/${connectorKey}/readme`)
  const responseText = await res.text()
  if (!responseText) {
    return null
  }
  return JSON.parse(responseText)
}
